import { render, staticRenderFns } from "./adm_modal.vue?vue&type=template&id=80baab52&scoped=true&"
import script from "./adm_modal.vue?vue&type=script&lang=js&"
export * from "./adm_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80baab52",
  null
  
)

export default component.exports